import dynamic from 'next/dynamic';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { getRegionColor } from '../../util/ColorUtil';
import {
  applyTruncationForScreen,
  countFacilityForMetro,
  getFacilityForMetro,
  isItUndefined,
  isLinkAbsolute,
  isMobile,
  isTablet,
  stripHtml,
  marketoOptions as options,
  getAlgoliaIndex,
  handleGoTo,
  formatFilters,
  addQueryParamWithoutRedirecting,
  removeQueryParam,
  removeNbsp,
  pushSearchSuggestionClickEvent,
  pushFilterUsageDataLayer,
} from '../../util/DataUtil';
import {
  excludeMetroDuplicateIDs,
  getAvaliableCloudFilters,
  getInfoBoxText,
  handleSeeMoreFacility,
  handleSeeMoreMetro,
  renderNoResult,
  getAvaliableCloudTetheredFilters,
} from '../../util/LocationsUtil';
import { formatCommaSeparator } from '../../util/RegexUtil';
import { useRouter } from 'next/router';
import { getMetricSystemForLanguage } from '../../util/LocationsUtil';
import {
  renderNoResults,
  renderFilterBox,
  renderFilterBoxTethered,
  sortMetros,
} from '../../util/MapsUtil';
import { SearchBarPlacement } from '../../constants/SearchBarPlacement';
import { FilterName } from '../../constants/FilterName';
import {
  sendClickedObjectIDsAfterSearch,
  sendNoResultsEvent,
  getToken,
} from '../../util/AlgoliaInsights';

const MapFilter = dynamic(() => import('../map/search/MapFilter'));
const Map = dynamic(() => import('../map/map'));

const TemplateRegionalMap = ({
  children,
  regionData,
  width,
  allMetros,
  lang,
  global,
  dataCenters,
}) => {
  const [metroData, setMetroData] = useState(regionData?.metros);
  const [query, setQuery] = useState('');
  const [filterProps, setFilterProps] = useState([]);
  const [languageFilter, setLanguageFilter] = useState([]);
  const [seeMoreMetro, setSeeMoreMetro] = useState(handleSeeMoreMetro(width));
  const [seeMoreFacility, setSeeMoreFacility] = useState(
    handleSeeMoreFacility(width)
  );
  const [isScrolled, setIsScrolled] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isDomLoaded, setIsDomLoaded] = useState(false);
  const [algoliaData, setalgoliaData] = useState([]);
  const [queryID, setQueryID] = useState(null);
  const [defaultLatitude, setDefaultLatitude] = useState(0);
  const [defaultLongitude, setDefaultLongitude] = useState(0);
  const [currentZoom, setCurrentZoom] = useState(
    children?.field_map_minimum_zoom[0]?.value
      ? Number(children?.field_map_minimum_zoom[0]?.value)
      : 3
  );
  const [tetheredFilters, setTetheredFilters] = useState([]);
  const [isToolTipActive, setIsToolTipActive] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [avaliableClouds, setAvaliableClouds] = useState(dataCenters || []);
  const [firstLoad, setFirstLoad] = useState(false);
  const [loadCount, setLoadCount] = useState(0);
  const [currentRegion, setCurrentRegion] = useState('');
  const router = useRouter();
  const metricSystem = getMetricSystemForLanguage(lang);

  const handleSearch = (search) => {
    setQuery(search.length !== 0 ? search : '');
    setIsFilterActive(false);
    setIsSearchActive(true);
  };

  useEffect(() => {
    if (!router?.query?.cloud && !router?.query?.certification) {
      return;
    }

    let matchCategory = [];
    let matchCerts = [];
    let certifications = getAvaliableCertifications(regionData.facilities);
    const cloudNames = Array.isArray(router.query.cloud)
      ? router.query.cloud
      : [router.query.cloud];
    const certNames = Array.isArray(router.query.certification)
      ? router.query.certification
      : [router.query.certification];

    if (cloudNames[0] !== undefined) {
      matchCategory = avaliableClouds.filter((item) =>
        cloudNames.some((cloudName) =>
          item.name.toLowerCase().includes(cloudName.toLowerCase())
        )
      );
    }

    if (certNames[0] !== undefined) {
      matchCerts = certifications.filter((item) =>
        certNames.some((certName) =>
          item.name.toLowerCase().includes(certName.toLowerCase())
        )
      );
    }

    // let filterProps = formatFilters(matchCategory);
    let filterProps = [...formatFilters(matchCategory), ...matchCerts];

    if (router?.query?.tethered === 'true') {
      setFirstLoad(true);

      filterProps = filterProps.reduce((result, obj) => {
        result.push(obj);
        if (!obj.name.includes('(T)') && !obj?.vid) {
          result.push({ name: obj.name + '(T)', tid: obj?.tid });
        }
        return result;
      }, []);
    }

    setFilterProps(filterProps);
  }, [router.query]);

  useEffect(() => {
    setMetroData(regionData.metros);
    setCurrentZoom(
      children?.field_map_minimum_zoom[0]?.value
        ? Number(children?.field_map_minimum_zoom[0]?.value)
        : 3
    );
    setDefaultLatitude(calculateMapCenter(regionData?.metros)?.latitude);
    setDefaultLongitude(calculateMapCenter(regionData?.metros)?.longitude);

    return () => {
      setMetroData([]);
      setCurrentZoom(3);
      setDefaultLatitude(0);
      setDefaultLongitude(0);
    };
  }, [regionData]);

  useEffect(() => {
    var input = document.getElementById('search-input');
    if (input && !isTablet(width) && !isMobile(width)) {
      input?.setAttribute('size', input?.getAttribute('placeholder')?.length);
    }
  }, [isDomLoaded]);

  const triggerFilter = (filters) => {
    setFilterProps(filters);

    let searchFilters = [];
    for (let filter of filters) {
      searchFilters.push(filter?.field_source_translation);
    }
  };

  useEffect(() => {
    let element = document.getElementsByClassName('bottom-part');
    let gradientElement = document.getElementsByClassName('gradient');
    for (let index = 0; index < element.length; index++) {
      for (let i = 0; i < gradientElement.length; i++) {
        if (index == i) {
          if (element[index].scrollLeft == 0) {
            gradientElement[i].style.display = 'block';
          } else {
            gradientElement[i].style.display = 'none';
          }
        }
      }
    }
  }, [isScrolled]);

  useEffect(() => {
    getSearchTerms(query, regionData?.metros, filterProps);
    getFromAlgolia(query);
  }, [query, filterProps, isToggled]);

  let facetFiltersArray = JSON.stringify([]);
  let tempLng = JSON.stringify('search_api_language:' + lang);

  const getFromAlgolia = async (query) => {
    if (query.length < 2) {
      return;
    }
    const userToken = getToken();
    const tokenParam = userToken ? `&userToken=${encodeURIComponent(userToken)}` : '';
    const indexName = `alllocations${getAlgoliaIndex()}`;
    const url =
      'https://O2VJB2KMPB-dsn.algolia.net/1/indexes/' +
      indexName +
      '?query=' +
      encodeURIComponent(query) +
      '&facetFilters=[' +
      facetFiltersArray +
      ',' +
      tempLng +
      ',["status:true"]]' +
      `&hitsPerPage=${1000}&clickAnalytics=true${tokenParam}`;
    await fetch(url, options)
      .then((response) => response.json())
      .then((algolia) => {
        setalgoliaData(algolia.hits);
        setQueryID(algolia.queryID || null);
        if (algolia.hits.length === 0) {
          sendNoResultsEvent(algolia.queryID, indexName);
        }
      });
  };

  const clearAll = () => {
    setFilterProps([]);
    triggerFilter([]);
    setLanguageFilter([]);
    setQuery('');
  };

  const clearQuery = () => {
    setQuery('');
    setIsSearchActive(false);
    setIsFilterActive(true);
  };

  const getAvaliableCertifications = (facilities) => {
    if (!facilities || !facilities.length) return;
    let result = [];

    facilities.map((item) => {
      if (item.field_certifications_compliance.length == 0) {
        return;
      }
      item.field_certifications_compliance.map((x) => {
        if (!x?.tid) {
          return;
        }
        result.push(x);
      });
    });
    return result.filter(
      (v, i, a) => a.findIndex((v2) => v2.tid === v.tid) === i
    );
  };

  const getSearchTerms = (query, data, filters) => {
    if (query == '' && filters.length == 0) {
      setMetroData(data);
    }

    let filteredMetros = [];

    // if(isFilterActive) {
    let facilityData = regionData.facilities;

    if (facilityData.length === 0) return;

    let result = facilityData.filter((item) => {
      return filters.some((filter) => {
        return (
          item.field_certifications_compliance.some(
            (e) => e?.name === filter?.name
          ) ||
          item.field_available_clouds?.some((e) =>
            e?.name.includes(filter?.name)
          ) ||
          item.field_available_tethered_t_acces?.some((e) =>
            e?.name.includes(filter?.name)
          )
        );
      });
    });

    setNoResults(result.length === 0);

    if (filters.length === 0) return;

    let metrosOfFacility = data.filter((metro) =>
      result.some(
        (facility) => facility.metro === metro.field_metro_name[0].name
      )
    );
    filteredMetros = [...new Set(metrosOfFacility)];
    setMetroData(filteredMetros);
    // }

    if (filteredMetros.length == 0) {
      setMetroData(data);
      return;
    }
  };

  const renderSearchResults = (query, filters) => {
    if (!query || query.length < 2) {
      return;
    }

    let filteredMetros;
    let filteredFacilities;
    if (isSearchActive) {
      filteredMetros = algoliaData.filter(
        (x) => x.type === 'metro' && x?.objectID?.endsWith(lang)
      );
      filteredFacilities = algoliaData.filter(
        (e) => e.type === 'location' && e?.objectID?.endsWith(lang)
      );

      let metroResult = [];

      filteredMetros?.map((metro) => {
        filteredFacilities.map((facility) => {
          if (facility.facility_metro == metro.metro_name) {
            metroResult.push(metro);
          }
        });
      });

      if (filteredFacilities?.length > 0) {
        allMetros?.map((metro) => {
          filteredFacilities.map((facility) => {
            if (facility.facility_metro == metro.metro) {
              metroResult.push(metro);
            }
          });
        });
      }

      // filteredMetros = [...new Set(metroResult), ...new Set(filteredMetros)];
      // filteredMetros = [...new Set(filteredMetros)]
      filteredMetros = [...new Set([...metroResult, ...filteredMetros])];
      filteredMetros = excludeMetroDuplicateIDs(filteredMetros);

      let metrosHtml = [];
      let facilitiesHtml = [];

      if (algoliaData?.length == 0) {
        return renderNoResult(global, clearAll);
      }

      let orderedMetros = sortMetros(filteredMetros, query);

      // filteredMetros.map((item, key) => {
      orderedMetros.map((item, key) => {
        metrosHtml.push(
          <div
            onClick={() => {
              pushSearchSuggestionClickEvent(
                Array.isArray(query)
                  ? (query[0]?.toLowerCase() ?? '')
                  : (query?.toLowerCase() ?? ''),
                SearchBarPlacement.DATA_CENTERS,
                item?.metro_name ? item?.metro_name : item?.metro,
                key + 1
              );
              sendClickedObjectIDsAfterSearch(queryID, item.objectID, `alllocations${getAlgoliaIndex()}`, key + 1);
              item?.url
                ? handleGoTo(item?.url, router, lang)
                : handleGoTo(item['url-alias'], router, lang);
            }}
            className="div-regional-map-link metro"
            key={`metro-index-${item?.metro_name || item?.metro || 'metro'}`}
          >
            <img alt="search" src={item?.metro_image} />
            <div className="right">
              <span className="title">
                {item?.metro_name ? item?.metro_name : item?.metro}
              </span>
              <span className="sub-title">
                {applyTruncationForScreen(
                  typeof item?.field_intro === 'string'
                    ? item?.field_intro
                    : isItUndefined(item?.field_intro),
                  90,
                  67,
                  67,
                  67
                )}
              </span>
            </div>
          </div>
        );
      });

      let numberOfFacilities = 0;

      filteredFacilities.map((item, key) => {
        numberOfFacilities++;
        facilitiesHtml.push(
          <div
            onClick={() => {
              pushSearchSuggestionClickEvent(
                Array.isArray(query)
                  ? (query[0]?.toLowerCase() ?? '')
                  : (query?.toLowerCase() ?? ''),
                SearchBarPlacement.DATA_CENTERS,
                item?.facility_metro + ' ' + item?.field_site_code_location,
                key + 1
              );
              sendClickedObjectIDsAfterSearch(queryID, item.objectID, `alllocations${getAlgoliaIndex()}`, numberOfFacilities);
              handleGoTo(item?.url, router, lang);
            }}
            key={`facility-index-${numberOfFacilities}`}
            className={`div-regional-map-link facility ${getRegionColor(item)}`}
          >
            <img alt="pin" src="/images/map-pin.svg" />

            <div className="right">
              <span className="title">
                {item?.facility_metro} {item?.field_site_code_location}
              </span>
              {/* <Link href={`http://maps.google.com/?q=${stripHtml(isItUndefined(item.field_address_location))}`} passHref> */}
              <a target="_blank" className="a-regional-map-link address">
                {removeNbsp(stripHtml(item?.facility_address))}
              </a>
              {/* </Link> */}
            </div>
          </div>
        );
      });

      return getHtmlResult(
        metrosHtml,
        facilitiesHtml,
        metrosHtml.length,
        numberOfFacilities
      );
    }

    if (filters.length || !filteredMetros?.length) {
      return;
    }

    if (algoliaData?.length == 0) {
      return renderNoResult(global, clearAll);
    }

    let metrosHtml = [];
    let facilities = [];
    let facilitiesHtml = [];

    filteredMetros.map((item, key) => {
      if (getFacilityForMetro(item?.field_metro_name, filteredFacilities)) {
        facilities.push(
          ...getFacilityForMetro(item?.field_metro_name, filteredFacilities)
        );
      }

      metrosHtml.push(
        <div
          onClick={() => router.push(item?.url)}
          className="div-regional-map-link metro"
          key={`metro-index-${item?.metro_name || 'metro'}`}
        >
          <img alt="search" src={item?.metro_image} />
          <div className="right">
            <span className="title">{item?.metro_name}</span>
            <span className="sub-title">
              {applyTruncationForScreen(item?.field_intro, 90, 67, 67, 67)}
            </span>
          </div>
        </div>
      );
    });

    facilities = [...new Set(facilities)];

    let numberOfFacilities = 0;

    facilities.map((item) => {
      numberOfFacilities++;
      facilitiesHtml.push(
        <div
          onClick={() => router.push(item?.url)}
          key={`facility-index-${numberOfFacilities}`}
          className={`div-regional-map-link facility ${getRegionColor(item)}`}
        >
          <img alt="pin" src="/images/map-pin.svg" />

          <div className="right">
            <span className="title">
              {item?.facility_metro} {item?.field_site_code_location}
            </span>
            <a target="_blank" className="a-regional-map-link address">
              {removeNbsp(stripHtml(item?.facility_address))}
            </a>
          </div>
        </div>
      );
    });
    return getHtmlResult(
      metrosHtml,
      facilitiesHtml,
      metrosHtml.length,
      numberOfFacilities
    );
  };

  const getHtmlResult = (
    metros,
    facilities,
    numberOfMetros,
    numberOfFacilities
  ) => {
    // facilities = facilities.slice(0, seeMoreFacility);
    // metros = metros.slice(0, seeMoreMetro);

    return (
      <>
        <div className="metro-results">
          <span className="regional-result-header">
            {global?.field_metro_label?.[0]?.value || 'Metro'} (
            {numberOfMetros})
          </span>
          {metros}
          {metros.length !== numberOfMetros && (
            <div
              className={'see-more'}
              onClick={() =>
                setSeeMoreMetro(seeMoreMetro + handleSeeMoreMetro(width))
              }
            >
              See More
            </div>
          )}
        </div>
        <div className="facility-results">
          <span className="regional-result-header">
            {global?.field_facility_label?.[0]?.value || 'Facility'} (
            {numberOfFacilities})
          </span>
          <div className="facilities">{facilities}</div>
          {facilities.length !== numberOfFacilities && (
            <div
              className={'see-more'}
              onClick={() =>
                setSeeMoreFacility(
                  seeMoreFacility + handleSeeMoreFacility(width)
                )
              }
            >
              See More
            </div>
          )}
        </div>
      </>
    );
  };

  const renderMetros = (data) => {
    if (!data || !data.length) return;

    return data.map((item, key) => {
      return (
        <div className="wrapper" key={`metro-index-${item?.['url-alias'] || item?.field_metro_name?.[0]?.name || 'metro'}`}>
          <Link
            target={isLinkAbsolute(item['url-alias']) ? '_blank' : '_self'}
            href={item['url-alias'] ? item['url-alias'] : ''}
            legacybehavior="true"
          >
            <a className="metro a-regional-map-link">
              <div className="top-part">
                <div className="top-left">
                  <span className="title">
                    {item?.field_metro_name[0]?.name}
                  </span>
                  <span className="sub-title">
                    {item?.field_bullets[0]?.value}
                  </span>
                </div>
                <span className={`circle ${getRegionColor(regionData)}`}>
                  {countFacilityForMetro(
                    item?.field_metro_name[0]?.original_tranlsation,
                    regionData?.facilities
                  )}
                </span>
              </div>
              <div
                onScroll={() => setIsScrolled(!isScrolled)}
                className="bottom-part"
              >
                {metricSystem == 'Imperial' ? (
                  <>
                    {item?.metro_total_facility_ft2 && (
                      <span>
                        {formatCommaSeparator(
                          Math.round(item?.metro_total_facility_ft2)
                        )}{' '}
                        ft <sup>2</sup>
                      </span>
                    )}
                    {item?.metro_total_facility_m2 && (
                      <span>
                        {formatCommaSeparator(
                          Math.round(item?.metro_total_facility_m2)
                        )}{' '}
                        m <sup>2</sup>
                      </span>
                    )}
                  </>
                ) : (
                  <>
                    {item?.metro_total_facility_m2 && (
                      <span>
                        {formatCommaSeparator(
                          Math.round(item?.metro_total_facility_m2)
                        )}{' '}
                        m <sup>2</sup>
                      </span>
                    )}
                    {item?.metro_total_facility_ft2 && (
                      <span>
                        {formatCommaSeparator(
                          Math.round(item?.metro_total_facility_ft2)
                        )}{' '}
                        ft <sup>2</sup>
                      </span>
                    )}
                  </>
                )}
                {item?.metro_total_facility_kw && (
                  <span>
                    {formatCommaSeparator(
                      Math.round(item?.metro_total_facility_kw)
                    )}{' '}
                    kW
                  </span>
                )}
                {item?.metro_total_facility_kw && (
                  <span>
                    {formatCommaSeparator(
                      Math.round(item?.metro_total_facility_kw)
                    )}{' '}
                    kW
                  </span>
                )}
                {item?.field_providers?.length > 0 ? (
                  <span>
                    {item?.field_providers[0].value}+{' '}
                    {isItUndefined(children?.field_providers_text)}
                  </span>
                ) : null}
                {item?.field_customers?.length > 0 ? (
                  <span>
                    {item?.field_customers[0].value}+{' '}
                    {isItUndefined(children?.field_customers_text)}
                  </span>
                ) : null}
                <div className="gradient"></div>
              </div>
            </a>
          </Link>
        </div>
      );
    });
  };

  const calculateMapCenter = (data) => {
    if (!data || !data.length) return;

    let latitudes = [];
    let longitudes = [];

    data.map((e) => {
      let latitude = Number(e?.field_latitude[0]?.value);
      let longitude = Number(e?.field_longitude[0]?.value);

      if (!latitude || !longitude) return;

      latitudes.push(latitude);
      longitudes.push(longitude);
    });

    const totalLatitude = latitudes.reduce(
      (total, currentItem) => (total = total + currentItem / latitudes.length),
      0
    );

    const totalLongitude = longitudes.reduce(
      (total, currentItem) => (total = total + currentItem / longitudes.length),
      0
    );

    return {
      latitude: totalLatitude,
      longitude: totalLongitude,
    };
  };

  const getDataForMetroMarkers = (data) => {
    if (!data || !data.length) return;

    let result = [];
    data.map((item) => {
      if (!item?.field_latitude[0]?.value || !item?.field_longitude[0]?.value)
        return;
      let numberOfFacilities = countFacilityForMetro(
        item?.field_metro_name[0]?.original_tranlsation,
        regionData?.facilities
      );

      let avaliableFilters = getAvaliableCloudFilters(
        item?.field_metro_name[0]?.original_tranlsation,
        regionData?.facilities
      );
      let flattenedList;
      if (avaliableFilters && avaliableFilters.length > 0) {
        flattenedList = [
          ...new Set(
            avaliableFilters?.flatMap((list) =>
              list?.map((item) => item && JSON.stringify(item))
            )
          ),
        ]?.map((item) => item && JSON.parse(item));
      }

      let availableFiltersTethered = getAvaliableCloudTetheredFilters(
        item?.field_metro_name[0]?.original_tranlsation,
        regionData?.facilities
      );
      let metroNameOriginalTranslation = item?.field_metro_name?.[0]?.original_tranlsation;
      const flattenedListTethered = [
        ...new Set(
          availableFiltersTethered.flatMap((list) =>
            list.map((item) => JSON.stringify(item))
          )
        ),
      ].map((item) => JSON.parse(item));

      result.push({
        latitude: Number(item?.field_latitude[0]?.value),
        longitude: Number(item?.field_longitude[0]?.value),
        regionColor: getRegionColor(regionData),
        title: item?.field_metro_name[0]?.name,
        subTitle: item?.field_intro[0]?.value,
        numberOfFacilities,
        link: item['url-alias'],
        infoText: getInfoBoxText(
          isItUndefined(children?.field_info_box_text),
          numberOfFacilities
        ),
        avaliableFilters: flattenedList?.length > 0 ? flattenedList : [],
        availableFiltersTethered:
          flattenedListTethered?.length > 0 ? flattenedListTethered : [],
        metroLocation:
          metroNameOriginalTranslation,
      });
    });
    return result;
  };

  const handleToggleChange = () => {
    setIsToggled(!isToggled);

    let url = '';

    if (typeof window !== 'undefined') {
      url = window.location.pathname;
    }

    if (isToggled) {
      // pushFilterUsageDataLayer(
      //   FilterName.REGION_MAP,
      //   'excludes tethered access'
      // );
      removeQueryParam(router, 'true'); // remove tethered from url
    } else {
      pushFilterUsageDataLayer(
        FilterName.REGION_MAP,
        'includes tethered access'
      );
      addQueryParamWithoutRedirecting(router, url, 'true', 'tethered');
    }
  };

  const handleToggleChangeOnFirstLoad = () => {
    if (loadCount < 1) {
      setIsToggled(true);
    }

    setLoadCount(1);
  };

  return (
    <div
      className="template-regional-map"
      onLoad={() => setIsDomLoaded(!isDomLoaded)}
    >
      <MapFilter
        lang={lang}
        router={router}
        clearQuery={clearQuery}
        isSearchActive={isSearchActive}
        isFilterActive={isFilterActive}
        setIsSearchActive={setIsSearchActive}
        setIsFilterActive={setIsFilterActive}
        data={[
          {
            id: 1,
            // Translatable label from global metrics; falls back to the English
            // literal so the filter group is never nameless if the CMS value is
            // not populated for a locale.
            name:
              isItUndefined(global?.field_certifications_label) ||
              'Certifications',
            description: '',
            children: getAvaliableCertifications(regionData.facilities),
          },
        ]}
        // avaliableClouds={[{id:2, name:'Available clouds on-ramps', description: '', children: formatFilters(avaliableClouds)}]}
        avaliableClouds={[
          {
            id: 2,
            name: isItUndefined(children?.field_filter_group_label),
            description: '',
            children: formatFilters(avaliableClouds),
          },
        ]}
        setQuery={setQuery}
        clearAll={clearAll}
        searchQuery={query}
        onSearchChange={handleSearch}
        search={children?.field_search_text[0]?.value}
        title={children?.field_filter_text[0]?.value}
        filterProps={filterProps}
        triggerFilter={triggerFilter}
        languageFilter={languageFilter}
        setLanguageFilter={setLanguageFilter}
        screenWidth={width}
        cancelText={isItUndefined(global?.field_cancel_text_translation)}
        applyFilterText={isItUndefined(global?.field_apply_filters_text)}
        clearAllText={isItUndefined(global?.field_clear_all_text)}
        selectedText={isItUndefined(global?.field_selected_text)}
        seeMoreText={isItUndefined(global?.field_see_more_text)}
        seeLessText={isItUndefined(global?.field_see_less)}
        toggleText={isItUndefined(children?.field_toggle_button_text)}
        onToggleChange={handleToggleChange}
        isToggled={isToggled}
        tooltipText={isItUndefined(children?.field_tooltip_text)}
        setTetheredFilters={setTetheredFilters}
        pageType={'regional-map'}
        component={'region'}
        firstLoad={firstLoad}
        handleToggleChangeOnFirstLoad={handleToggleChangeOnFirstLoad}
        dataLayerFilterName={FilterName.REGION_MAP}
      />
      <div className="inner-container">
        {typeof renderSearchResults(query, filterProps) == 'object' && (
          <div className="search-result-container">
            {renderSearchResults(query, filterProps)}
          </div>
        )}
      </div>

      <div className="regional-map-container">
        <div className="metro-container">
          <div className="metro-header">
            <div className="metro-inner-container">
              <div className="metro-wrapper">
                <span>
                  {metroData.length} {children?.field_title[0]?.value}
                </span>
              </div>
            </div>
          </div>
          <div className="metro-wrapper">
            <div className="metro-inner-container">
              {renderMetros(metroData)}
            </div>
          </div>
        </div>
        <div className="map-container">
          <Map
            blockTypeClass={'regional-map'}
            filterText={isItUndefined(children?.field_filter_group_label)}
            filterTextTethered={isItUndefined(
              children?.field_filter_group_2_label
            )}
            currentZoom={currentZoom}
            setCurrentZoom={setCurrentZoom}
            width={width}
            maxZoom={Number(children?.field_map_maximum_zoom[0]?.value)}
            latitude={defaultLatitude}
            longitude={defaultLongitude}
            renderMarkers={getDataForMetroMarkers(metroData)}
            regionalMap={true}
            isToggled={isToggled}
            setCurrentRegion={setCurrentRegion}
          />
          {/* {
                    (noResults && filterProps.length > 0)
                    ?
                    <div className={'filter-info-box no-results'}>
                        {renderNoResults(children?.field_no_results_text)}
                    </div>
                    :
                    tetheredFilters?.length > 0 &&
                    <div className={isToggled ? 'filter-info-box tethered' : 'filter-info-box'}>
                        {renderFilterBox(tetheredFilters, children?.field_filter_display_text)}
                        { isToggled && renderFilterBoxTethered(tetheredFilters, children?.field_filter_display_text_2) }
                    </div>
                } */}
        </div>
      </div>
    </div>
  );
};

export default TemplateRegionalMap;
